import {BaseIdModel} from 'common-shared';
import {Exclude} from "class-transformer";

export class HierarchyNodeModel extends BaseIdModel {
  constructor(init?: Partial<HierarchyNodeModel>) {
    super();
    Object.assign(this, init);
  }
  Name: string;
  ParentId?: string;
  Children: HierarchyNodeModel[];
  Type: string;
  @Exclude()
  IsSelected: boolean;
  @Exclude()
  IsExpanded: boolean = true;
}
